const ATTRIBUTION_CHANNEL_COLORS = {
  paid_social: 'blue',
  paid_search: 'indigo',
  other_paid: 'blue-light',
  email: 'brand',
  sms: 'purple',
  conductor: 'brand',
  partner: 'gray-blue',
  organic_social: 'pink',
  organic_search: 'success',
  referral: 'orange',
  tracking_link: 'warning',
  promo_code: 'orange',
  box_office: 'gray-blue',
  comp_guest_list: 'gray-blue',
  distribution_partner: 'gray-blue',
};

export const attributionChannelColor = (channel) => ATTRIBUTION_CHANNEL_COLORS[channel] || 'gray';

export default ATTRIBUTION_CHANNEL_COLORS;

// ponytail: Setlist has no chart palette tokens yet; these are its utility-ramp hexes, readable on light and dark surfaces
const ATTRIBUTION_CHANNEL_CHART_COLORS = {
  paid_social: '#2E90FA',
  paid_search: '#A4BCFD',
  other_paid: '#0BA5EC',
  email: '#1982C4',
  sms: '#7A5AF8',
  conductor: '#85C6EF',
  partner: '#4E5BA6',
  organic_social: '#EE46BC',
  organic_search: '#8AC926',
  referral: '#EF6820',
  tracking_link: '#FDB022',
  promo_code: '#F7B27A',
  box_office: '#4E5BA6',
  comp_guest_list: '#4E5BA6',
  distribution_partner: '#4E5BA6',
};

export const attributionChannelChartColor = (channel) => ATTRIBUTION_CHANNEL_CHART_COLORS[channel] || '#A4A7AE';
